export const products = {
  fields: {
    code: '编码',
    maVach: '条码',
    maQR: '二维码',
    name: '商品名称',
    donViCoBan: '基本单位',
    customsNameEn: '海关申报名（英文）',
    customsNameVi: '海关申报名（越文）',
    tenKhaiBaoVi: '申报名（越文）',
    tenKhaiBaoEn: '申报名（英文）',
    description: '描述',
    status: '经营状态',
    actions: '操作',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    declarationType: '申报类型',
    productCategory: '产品组',
    priceGroup: '价格组',
    declarationGroup: '申报组',
    registeredCompany: '注册公司',
    exporterCompany: '出口伙伴',
    importerCompany: '进口公司',
    conditionalItem: '条件货品',
    certificate: '证书',
    sampleTestRequired: '是否需要抽样检测',
    declarationStartDate: '申报开始日期',
    declarationEndDate: '申报结束日期',
    declarationFee: '申报费用',
    qualityFee: '质检费用',
    unitCost: '内部成本单位',
    declarationUnit: '申报单位',
    fixedConditionName: '固定条件名称',
    isSensitive: '敏感货品',
    businessNote: '业务备注',
    note: '备注',
    parentId: '父级组 ID',
    parentGroup: '父级组',
    onOffAction: '经营',
    nhomHang: '商品组',
    giaBan: '售价',
    giaVon: '成本价',
    tonKho: '库存',
    khachDat: '客户订货',
    thumbnail: '图片',
    loaiHang: '商品类型',
    yeuThich: '收藏',
    banTrucTiep: '直接销售',
    baoHanh: '保修',
    moTa: '描述',
    thuongHieuId: '品牌',
    nhaCungCapId: '供应商',
    viTriId: '商品库位',
    viTriSanPham: '商品库位',
    dinhMucTonThapNhat: '最低库存',
    dinhMucTonCaoNhat: '最高库存',
    trongLuong: '箱重',
    giaTriTonKho: '库存金额',
    quyCachThung: '箱规',
    theTichThung: '箱体积',
    tongTrongLuongTon: '库存总重量 (kg)',
    tongTheTichTon: '库存总体积',
    chieuDai: '长度 (cm)',
    chieuRong: '宽度 (cm)',
    chieuCao: '高度 (cm)',
    canNangKien: '件重',
    quyCachKien: '件规格',
    donViTrongLuong: '重量单位',
    thoiGianBaoHanh: '保修期 (月)',
    loaiBaoHanh: '保修类型',
    phamVi: '适用范围',
    danhSachChiNhanhIds: '适用分店',
    hinhAnh: '图片',
    danhSachThanhPhan: '组合成分',
    tenDonViCoBan: '基本单位名称',
    thuocTinhs: '属性',
  },
  donViTrongLuong: {
    g: '克 (g)',
    kg: '千克 (kg)',
    mg: '毫克 (mg)',
  },
  loaiBaoHanh: {
    baoHanh: '保修',
    baoTri: '维护',
    caHai: '保修与维护',
  },
  phamVi: {
    toanDuAn: '全项目',
    theoChiNhanh: '按分店',
    chonTatCaMang: '全选',
    boChonTatCaMang: '取消',
    emptyBranches: '暂无可选分店',
  },
  trangThai: {
    dangKinhDoanh: '在售',
    ngungKinhDoanh: '停售',
    /** 停售后的操作按钮 — 重新开售。 */
    moKinhDoanh: '重新开售',
  },
  loaiHang: {
    hangHoa: '商品',
    combo: '组合',
  },
  combo: {
    addRow: '添加组合成分',
    soLuong: '数量',
    placeholder: '选择商品成分',
    noOptions: '未找到商品',
    giaVonAutoHint: '根据组合成分自动计算',
    loading: '加载中…',
    hint: '选择构成该组合的商品及其对应数量。',
    empty: '暂无组合成分',
    remove: '删除',
    columnStt: '序号',
    columnMaHang: '商品编码',
    columnTenHang: '成分名称',
    columnGiaVon: '成本价',
    columnTongGiaVon: '总成本',
    columnGiaBan: '售价',
    columnTongGiaBan: '总售价',
  },
  donViTinhVaThuocTinh: {
    title: '单位与属性管理',
    donViTinhSubtitle: '单位',
    donViTinhDescription:
      '添加销售或进货单位（如瓶、条、箱）。设置换算公式可快速计算价格与库存。例如：1 条 = 4 瓶，1 箱 = 20 条。',
    thuocTinhSubtitle: '属性',
    thuocTinhDescription: '添加口味、容量、颜色等特征',
    themThuocTinh: '添加属性',
    tenThuocTinhPlaceholder: '属性名（如：口味）',
    giaTriThuocTinhPlaceholder: '属性值（如：香草）',
    chonThuocTinhPlaceholder: '— 选择属性 —',
    chonGiaTriPlaceholder: '— 选择值 —',
    nhapGiaTriPlaceholder: '输入值',
    coBanLabel: '单位',
    donViCoBanLabel: '单位',
    placeholderTenDonViCoBan: '— 选择单位 —',
    donViCoBanRequired: '请选择单位',
    tyLeQuyDoiKhongHopLe: '单位「{ten}」的换算比例必须大于 0',
    donViCoBanAutoResetToast: '更改基本单位后已自动清除换算单位',
    themDonVi: '添加单位',
    emptyDonVi: '尚无换算单位。点击"添加单位"进行添加。',
    duplicateName: '列表中已存在该单位名称',
    labelTenDonViQuyDoi: '单位名称',
    labelGiaTriQuyDoi: '换算值',
    labelSlDonViCoBan: '基本单位数量',
    labelSlDonViQuyDoi: '换算单位数量',
    labelGiaBanQuyDoi: '售价（换算 SKU）',
    placeholderTenDonViQuyDoi: '例如：箱',
    giaBanPlaceholder: '0',
    invalidTyLe: '基本/换算数量必须 > 0（允许小数，如 45.7）',
    hangCungLoaiSubtitle: '同类商品',
    hangCungLoaiDescription:
      '每个换算单位会自动创建一个独立商品，与基础商品按换算比例共享库存。',
    colDonVi: '单位',
    colQuyDoi: '换算',
    colMaHang: '商品代码',
    thietLapGia: '设置价格',
    maHangPreview: '(自动)',
  },
  viTriTrongLuong: {
    title: '库位 · 尺寸 · 重量',
    description: '库位、尺寸与箱重 / 箱规',
  },
  /** Card "Tồn kho". */
  tonKhoSection: {
    title: '库存',
    description: '管理库存数量与库存上下限。当库存达到上下限时，系统将发送提醒。',
    quanLySerialIMEI: '按序列号/IMEI 管理',
    quanLyTheoHanSuDung: '按保质期管理',
  },
  tonKhoVaViTri: {
    title: '库存 · 位置',
  },
  loHang: {
    colMaLo: '批次号',
    colHanSuDung: '保质期',
    colSoLuong: '数量',
    colGiaVon: '成本价',
    colTrangThai: '状态',
    trangThai: {
      khongRo: '未知',
      conHan: '在保质期',
      canHan: '即将过期 (<7天)',
      hetHan: '已过期',
    },
    notEnabled: '此商品未启用保质期管理。',
    empty: '暂无批次。',
    unit: '批次',
  },
  giaBanSection: {
    title: '成本价 · 默认售价',
    thietLapGia: '按价格表定价',
    giaBanPlaceholder: '0',
    giaVonPlaceholder: '0',
    setupDialogTitle: '按价格表定价',
    setupDialogSubtitle: '当前有 {count} 个生效价格表',
    setupDialogHint:
      '点击售价单元格为该价格表单独设价。完成 → 保存商品后生效。留空则使用表单上的默认售价。',
    setupDialogHintAdd:
      '新建商品时，已配置公式的价格表会根据表单上的成本价/售价自动计算。可手动修改，或点击“应用公式”重新计算。完成 → 保存商品后生效。',
    setupDialogHintMatrix:
      '首列为商品编码；其后各列为基本单位与换算单位。每行一个价格表 — 按单位输入售价。有公式的会预填；可手改或点“应用公式”。完成 → 保存商品后生效。',
    setupDialogPlaceholder: '输入价格',
    setupDialogColBangGia: '价格表',
    setupDialogColGiaBan: '售价',
    setupDialogEmpty: '暂无生效价格表。请先在价格表菜单中创建。',
    setupDialogSkip: '跳过',
    setupDialogDone: '完成',
    setupDialogSaveSuccess: '已应用所选价格表的价格。',
    setupDialogSavePartial: '部分价格表更新失败',
    setupDialogApDungCongThuc: '应用公式',
    setupDialogApDungTooltip:
      '按各价格表公式重算基本单位列，再按单位换算比例填充其余列。',
    setupDialogApDungSuccess: '已为 {applied}/{total} 个单元格按公式/换算比例填充建议价格。',
    setupDialogApDungEmpty: '没有可应用公式的价格表。',
    setupDialogApDungNoChange:
      '无法计算价格（缺少成本价/来源价格表价格/基本单位列价格以换算）。请检查表单。',
    setupDialogBadgeChuaCoGia: '尚未定价',
    setupDialogBadgeSeXoa: '将被移除',
    setupDialogHintSeXoa:
      '该价格表已不再生效（已删除/停用）。点击“完成”并保存商品后，商品在该表上的价格将被清除。不可编辑。',
    setupDialogBangGiaDaXoa: '已删除的价格表',
    setupDialogBangGiaBiXoaWarning:
      '价格表已删除：{names}。点击“完成”并保存商品后将清除该商品在这些表上的价格。这些行不可编辑。',
    setupDialogWarningTyLeQuyDoi:
      '若刚在表单下方修改单位换算比例，请点击“应用公式”以按基本价×比例更新换算单位列价格。',
    setupDialogApDungHangTooltip: '对本价格表应用公式（含换算单位）。',
    setupDialogApDungCotTooltip: '对本单位列应用公式/换算比例。',
    tyLeChangedBangGiaWarning:
      '需要更新价格表。请打开“按价格表定价”并点击“应用公式”。',
  },
  /** 弹窗"设置同类商品价格"（单位 × 价格表 矩阵）。 */
  hangCungLoaiGia: {
    dialogTitle: '设置同类商品价格',
    dialogSubtitle: '有 {count} 个单位需要按价格表设置价格',
    chooseBangGia: '应用的价格表',
    colDonVi: '单位',
    colGiaVon: '成本价',
    colGiaBanChung: '基础售价',
    emptyRows: '暂无换算单位。请先在上方添加单位。',
    emptyBangGia: '暂无生效的价格表。',
    skip: '跳过',
    done: '完成',
    hint:
      '每个单位下列出价格表（按行输入）。已配置公式的价格会按成本价/基础售价预填。点击价格可修改，或点“应用公式”重新计算。',
    apDungCongThuc: '应用公式',
    apDungTooltip: '按各价格表公式快速填入所有单位的价格。仅已配置公式的价格表会变更。',
    saveSuccess: '已应用同类商品价格。',
    savePartial: '部分同类商品价格更新失败',
  },
  tonKho: {
    tatCa: '全部',
    conHang: '有货',
    hetHang: '缺货',
  },
  status: {
    all: '全部',
    active: '启用',
    inactive: '停用',
  },
  common: {
    yes: '是',
    no: '否',
  },
  sampleTests: {
    Co: '是',
    Khong: '否',
    TuyTruongHop: '视情况而定',
  },
  filters: {
    all: '全部',
    productGroupSection: '商品组',
    treeAll: '全部',
    treeSearch: '搜索商品组',
    productGroupHint: '选择分组筛选（含子组）。在商品组菜单维护分类树。',
    openProductCategories: '打开产品组列表',
    openNhomHang: '打开商品组管理',
    loaiHang: '商品类型',
    attributesSection: '属性',
    loaiHangThuong: '普通商品',
    loaiHangSanXuat: '生产商品',
    loaiHangDichVu: '服务',
    loaiHangCombo: '组合 / 套装',
    productTypeSection: '商品类型',
    sortSection: '排序',
    sortBy: '排序字段',
    sortDirection: '排序方向',
    sortOrder: '顺序',
    maHangHoa: '商品编码',
    tenHangHoa: '商品名称',
    maNhomHang: '分组编码',
    tenNhomHang: '分组名称',
    ngayTaoTu: '创建日期从',
    ngayTaoDen: '创建日期至',
    asc: '升序',
    desc: '降序',
    choiceTitle: '选项筛选',
    textDetailTitle: '多字段搜索',
    clearToolbar: '清除筛选',
    notSelected: '— 请选择 —',
    sortDefault: '默认',
    maVach: '条码',
  },
  declarationTypes: {
    CO: 'C/O',
    Phyto: '植物检疫 (Phyto)',
    Fumigation: '熏蒸 (Fumigation)',
    Khac: '其他',
  },
  messages: {
    khongDuocAm: '数值不能为负数',
    trungTenConfirmTitle: '商品名称重复',
    trungTenConfirmMessage: '已存在商品「{ten}」（编码 {ma}）。仍要使用此名称保存吗？',
    soAmConfirmTitle: '确认负数',
    soAmConfirmMessage: '以下字段为负数：{fields}。确定要保存吗？',
    listSummary: '合计 {count} 条（按筛选条件）',
    noData: '暂无数据',
    scaffoldHint: '这是产品模块的初始脚手架。下一步可以继续接入 API、筛选、增改弹窗以及更细的权限控制。',
    saving: '保存中...',
    importDescription: '请选择符合模板的 Excel 文件导入产品数据。',
    importSuccess: '导入成功',
    importFailed: '导入失败',
    bulkDeleteSuccess: '已删除所选商品。',
    bulkNgungSuccess: '已将所选商品设为停售。',
    bulkNgungPartial: '已停售 {ok}/{total}；失败 {fail}。',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    uploadingImage: '正在上传图片…',
    pasteImageHint: '在框内 Ctrl+V 或点击粘贴图片',
    pasteImageNoImage: '剪贴板中没有图片。请复制图片或粘贴 http(s) 链接。',
    imageHint: '每张图片不超过 2 MB',
    noThuongHieuOptions: '没有品牌',
    noDonViTinhOptions: '没有计量单位',
    galleryHint: '可上传多张图片。第 1 张为封面图。',
    setAsMainImage: '设为封面图',
    mainImage: '封面',
    dragDropImageHint: '拖放图片到此处，或点击选择',
    maxImageSizeHint: '限制：每个文件 20 MB',
    noHistory: '暂无交易记录',
    historyComingSoon: '交易历史功能即将上线（入库单、发票、订单）。',
    barcodePrintHint: '使用下方按钮选择条码格式并打印标签。',
    comingSoon: '功能开发中',
    branchRequired: '范围为“按分支”时请选择分支',
  },
  export: {
    titles: {
      selectColumns: '选择显示列',
    },
    hints: {
      selectAtLeastOne: '请至少选择 1 列以导出文件',
      required: '必选',
      theoChiNhanh:
        '库存、成本、客户订货和供应商订货按分店分行导出，不再是全部门店合计。',
    },
    actions: {
      selectAll: '全选',
      deselectAll: '取消全选',
      xuatTheoMauNhap: '按导入模板导出',
      resetAll: '全部选择',
    },
    messages: {
      selectedCount: '已选择 {selected}/{total} 列',
      noColumnSelected: '请至少选择 1 列',
    },
    groups: {
      hangHoa: '商品',
      giaBanTonKho: '售价与库存',
      donViTinh: '计量单位',
      thuocTinh: '属性',
      serialImei: 'Serial/IMEI',
      thongTinKhac: '其他信息',
    },
    columns: {
      datNcc: '供应商订单',
      duKienHetHang: '预计缺货',
      donViQuyDoi: '换算',
      maDonViCoBan: '基本单位代码',
      maHangLienQuan: '关联商品代码',
      suDungImei: '使用 IMEI',
      serialImei: 'Serial/IMEI',
      baoTriDinhKy: '定期维护',
    },
  },
  actions: {
    deleteSelected: '删除已选 ({count})',
    deleteSelectedMenu: '删除已选',
    ngungKinhDoanhSelected: '停售 ({count})',
    createHoaDonSelected: '创建发票 ({count})',
    createDatHangSelected: '创建订单 ({count})',
    createDatHangMenu: '创建订单',
    createPhieuNhapSelected: '创建入库单 ({count})',
    createPhieuNhapMenu: '创建入库单',
    createPhieuXuatSelected: '创建出库单 ({count})',
    createPhieuXuatMenu: '创建出库单',
    createXuatHuySelected: '创建报废出库 ({count})',
    createXuatHuyMenu: '创建报废出库',
    createKiemKeSelected: '创建盘点 ({count})',
    createKiemKeMenu: '创建盘点',
    createChuyenHangSelected: '创建调拨 ({count})',
    createChuyenHangMenu: '创建调拨',
    chooseImage: '选择图片',
    pasteImage: '粘贴图片',
    printBarcode: '打印条码',
    printBarcodeTitle: '打印条码 — {name}',
    saveAndCreate: '保存并继续新增',
    saveAndCopy: '保存并复制',
    skip: '跳过',
    createNew: '新增',
    quickCreateGroup: '新增',
    selectAllGroups: '全选',
    deselectAllGroups: '取消全选',
    applyGroups: '应用',
  },
  formFooter: {
    banTrucTiepTooltip: '启用后，商品可在 POS 直接销售。关闭时只能通过订单销售。',
  },
  /** 新增/编辑商品弹窗标签 (`ProductPopup` / `ProductForm`)。 */
  detailTabs: {
    generalInfo: '基本信息',
    gallery: '图片',
    barcode: '条码',
    history: '交易历史',
  },
  /** 列表展开行标签 (`ProductListInlineDetail`)。 */
  inlineDetailTabs: {
    info: '信息',
    description: '描述、备注',
    stockCard: '库存卡',
    pendingStockCard: '待处理库存卡',
    inventory: '库存',
    thongTinVat: '增值税开票信息',
    salesChannels: '销售渠道关联',
  },
  /** 删除确认对话框（操作列 / 批量 / 展开行）。 */
  deleteDialog: {
    title: '删除商品',
    bodyNoCode: '系统将在所有分店中彻底删除该商品，但保留其在历史交易中的记录（如有）。确定要删除吗？',
    bodyIntro: '系统将',
    bodyOutro: '在所有分店中删除该商品，但保留其在历史交易中的记录（如有）。',
    bodyAndMore: '... 以及其他 {count} 个',
    bodyConfirm: '确定要删除吗？',
  },
  bulkNgungDialog: {
    title: '停售商品',
    body: '将停售所选 {count} 个商品（全系统）？历史交易保留，重新开售前不可销售。',
  },
  /** “描述、备注”标签 — 2 卡片（描述 / 订货备注）。 */
  descriptionTab: {
    descriptionLabel: '描述',
    orderNoteLabel: '订货备注',
    emptyDescription: '暂无描述',
    emptyOrderNote: '暂无备注',
  },
  /** 库存标签内容 — 按分店子表。 */
  inventoryTab: {
    searchPlaceholder: '搜索分店名称',
    totalLabel: '合计',
    empty: '暂无任何分店拥有此商品',
    emptyHint: '此商品尚未分配到任何分店。',
    comingSoonHint: '功能开发中',
    cols: {
      chiNhanh: '分店',
      tonKho: '库存',
      datNcc: '采购在途',
      khachDat: '客户订货',
      duKienHetHang: '预计缺货',
      topSale: 'Top sale',
      nonmoving: 'Nonmoving',
      giaTriTonKho: '库存价值',
      quyCachThung: '箱规格',
      theTichThung: '箱体积',
      trongLuong: '箱重量',
      tongTrongLuongTon: '总库存重量 (kg)',
      tongTheTichTon: '总库存体积',
      viTriSanPham: '商品库位',
      trangThai: '状态',
    },
    notAvailable: '---',
  },
  /** 库存卡 — 当前分店出入库交易（含草稿）. */
  stockCardTab: {
    empty: '当前分店暂无此商品已完成的出入库交易',
    emptyPending: '当前分店暂无未影响库存的草稿 / 待审核单据',
    emptyFiltered: '没有符合筛选条件的交易',
    filters: {
      searchPlaceholder: '按单号、关联单据号搜索',
      dateRange: '凭证日期',
      from: '开始日期',
      to: '结束日期',
      allLoaiPhieu: '全部单据类型',
      allNhap: '全部入库单',
      allXuat: '全部出库单',
      khachHang: '客户编码、名称',
    },
    actions: {
      exportExcel: '导出 Excel',
      helpCalc: '计算说明',
    },
    helpModal: {
      title: '库存与成本如何计算',
      close: '关闭',
      intro:
        '库存卡按凭证日期（旧→新）回放当前门店已完成单据。主要目的：为每次出库挂正确成本以便算毛利。',
      tonTitle: '1. 结存数量',
      tonBody: '每行按带符号数量累加：',
      tonLi1: '入库：+数量',
      tonLi2: '出库：−数量',
      tonLi3: '盘点：使用单据上的正负数量',
      tonFormula: '结存 = 上期结存 + 带符号数量\n带符号 = 入 − 出（盘点按单据符号）',
      gvNhapTitle: '2. 入库行成本',
      gvNhapBody:
        '入库行「成本」列 = 入库后的加权平均成本，不等于单据单价（库存≤0/为负时除外）。',
      gvNhapLi1: '入库前库存 > 0：与旧均价做标准加权平均',
      gvNhapLi2: '入库前库存 = 0 或尚无均价：成本 = 入库价（单价 − 折扣）',
      gvNhapLi3: '入库前库存 < 0：成本 = 入库价（不再 ÷ 结存）',
      gvNhapFormula:
        '库存 > 0：\n  均价 = (库存 × 旧均价 + 数量 × 入库价) / (库存 + 数量)  → 四舍五入 2 位\n库存 ≤ 0 或为负：\n  均价 = 入库价',
      gvXuatTitle: '3. 出库行成本',
      gvXuatBody: '用于计算出库毛利：',
      gvXuatLi1: '出库前库存 > 0：成本 = 出库前均价；均价不变',
      gvXuatLi2: '负库存出库（出库前 ≤ 0）：成本 = 最近均价 (lastAvg)',
      gvXuatLi3: '从未有过入库形成均价 → 成本 = 0',
      giaTriTitle: '4. 结存金额',
      giaTriBody: '库存卡每行显示：',
      giaTriFormula: '结存金额 = 结存数量 × 行成本',
      noteTitle: '说明',
      noteLi1: '按凭证日期排序（旧→新），不是系统创建时间。',
      noteLi2: '取消入库单时，若后续已出完数量，允许库存为负。',
      noteLi3: '导出 Excel 含「Kiem tra CT」核对公式页。',
    },
    summary: {
      tonDauKy: '期初库存',
      tongNhap: '入库合计',
      tongXuat: '出库合计',
      tonCuoiKy: '期末库存',
      tonHienTai: '当前库存',
      tongNhapCho: '待入库',
      tongXuatCho: '待出库',
      tonDuKien: '预计库存',
    },
    cols: {
      ngayChungTu: '凭证日期',
      ngayTao: '创建时间',
      maPhieu: '单号',
      loaiPhieu: '类型',
      maChungTu: '关联单据号',
      doiTac: '往来单位',
      nhapXuat: '入/出库',
      donGia: '交易价',
      giaVon: '成本价',
      tonCuoi: '结存',
      giaTriTonCuoi: '结存金额',
      trangThai: '状态',
      ghiChu: '备注',
    },
    loaiChungTu: {
      hoaDon: '发票',
      traHang: '退货',
      chuyenHang: '调拨',
      nhanHang: '收货',
      datHangNCC: '采购订单',
      kiemKe: '盘点',
    },
    trangThaiPhieu: {
      phieuTam: '草稿',
      cho: '待审核',
      daHoanThanh: '已完成',
    },
    loaiPhieu: {
      NHAP_MUA: '采购入库',
      NHAP_CHUYEN: '调拨入库',
      NHAP_TRA_HANG: '退货入库',
      NHAP_DIEU_CHINH: '调整入库',
      NHAP_KHAC: '其他入库',
      XUAT_BAN: '销售出库',
      XUAT_CHUYEN: '调拨出库',
      XUAT_TRA_NCC: '退供应商',
      XUAT_HUY: '报废出库',
      XUAT_NOI_BO: '内部出库',
      XUAT_DIEU_CHINH: '调整出库',
      XUAT_KHAC: '其他出库',
      KIEM_KE: '盘点',
    },
  },
  formTabs: {
    info: '信息',
    description: '描述',
    warranty: '保修与维护',
    branchBusiness: '经营分支',
    global: '全系统',
  },
  formColumns: {
    thongTin: '信息',
    lienKet: '关联',
  },
  detailFields: {
    stockLimit: '库存上下限',
  },
  detailActions: {
    copy: '复制',
    addUnit: '添加计量单位',
    addAttribute: '添加属性',
    viewDetail: '详情',
    detailTitle: '商品详情',
    moreActions: '更多操作',
  },
  titles: {
    addQuick: '快速新增',
    addNew: '新增',
    importKiot: '导入',
    exportFile: '导出文件',
    createModal: '新建商品',
  },
  import: {
    xuLyTrungMaKhacTen: '编码相同但名称不同',
    xuLyTrungBaoLoi: '报错并跳过',
    xuLyTrungThayThe: '替换已有记录',
    capNhatTonKho: '根据文件更新库存',
    capNhatGiaVon: '根据文件更新成本价',
    capNhatMoTa: '根据文件更新描述',
  },
  menu: {
    addProduct: '商品',
    addProductGroup: '商品组',
  },
  aria: {
    addSplit: '打开新增选项',
    createVoucherSplit: '打开从所选商品创建单据的选项',
    bulkManageSplit: '打开删除所选商品选项',
    columnPicker: '选择显示列',
    selectAllPage: '全选本页',
    selectRow: '选择行',
    toggleStar: '星标',
    chonDonViTinh: '选择单位',
    quickCreateGroup: '新建商品分组',
    editGroup: '编辑商品分组',
    selectAllGroups: '全选商品分组',
    deselectAllGroups: '取消全选商品分组',
    applyGroups: '应用商品分组筛选',
  },
  placeholders: {
    codeAuto: 'SP00000001',
    name: '必填',
    searchParentCategory: '搜索父级组编码或名称…',
    searchCodeName: '按编码、名称',
    chonNhomHang: '选择商品分组',
    selectedGroupsCount: '已选 {count} 个分组',
    searchByNoteDesc: '按备注、订货描述',
    searchByCode: '编码',
    searchByName: '名称',
    pickNhomHang: '选择商品组（必填）',
    pickNhaCungCap: '按编码或名称搜索供应商…',
    pickThuongHieu: '选择品牌',
    pickViTri: '选择一个或多个库位',
    pickDonViTinh: '按编码或名称搜索单位…',
    maVach: '输入条码',
    maQR: '输入二维码',
    tenKhaiBaoVi: '越文申报名',
    tenKhaiBaoEn: '英文申报名',
    danhSachChiNhanhIds: '例：1, 2, 3（范围为按分店时）',
    moTa: '输入描述',
    note: '输入备注',
  },
  sections: {
    productCategories: {
      title: '产品组',
      detailTitle: '产品组详情',
      description: '管理产品分类组，用于统一商品分类。',
      viewBasic: '基本信息',
      viewLinkage: '父级分组',
      viewStatus: '状态',
      viewAudit: '系统信息',
    },
    priceGroups: {
      title: '价格组',
      detailTitle: '价格组详情',
      description: '管理适用于不同产品或客户分组的价格体系。',
      viewBasic: '基本信息',
      viewLinkage: '父级分组',
      viewStatus: '状态',
      viewAudit: '系统信息',
    },
    declarationGroups: {
      title: '申报组',
      detailTitle: '申报组详情',
      description: '管理产品申报分组，用于规范申报和资料归档。',
      viewBasic: '基本信息',
      viewDeclaration: '申报信息',
      viewLinkage: '父级分组',
      viewStatus: '状态',
      viewAudit: '系统信息',
    },
    products: {
      title: '货品',
      detailTitle: '货品详情',
      description: '管理货品、分组、价格与库存。',
      viewBasic: '基本信息',
      viewLinkage: '分类与关联',
      viewDeclarationAndFees: '申报、费用与条件',
      viewPricing: '价格与库存',
      viewFlags: '属性',
      viewPricingFlags: '价格与库存 · 属性',
      viewCombo: '组合成分',
      viewNotes: '备注',
      viewStatus: '状态',
      viewAudit: '系统信息',
      viewImage: '图片',
    },
  },
  badges: {
    hangCungLoai: '同类',
    hangCungLoaiTooltip: '同类商品',
  },
  importMenu: {
    hangHoa: '商品',
    viTri: '商品库位',
    anh: '商品图片',
    thongTinVat: '商品增值税信息',
  },
  anhImport: {
    titles: {
      modal: '导入商品图片',
      errors: '错误行列表',
    },
    actions: {
      open: '导入图片',
      template: '下载模板',
    },
    options: {
      question: 'Excel 布局（选文件前先选）',
      doc: '纵向 — 两列（A: 编码，B: 图片）',
      ngang: '横向 — A: 编码，图片从 B 列起 → …',
      url: '图片 URL — A: 编码，B: url1,url2…（下载后存入本系统）',
    },
    hints: {
      doc: '每行：编码 + B 列图片。同一编码多行可加多张图。',
      ngang: '每行：A 列为编码；B、C、D… 各放一张图。',
      url: '每行：A 为编码；B 为图片 URL（http/https），多个用逗号分隔。系统会下载并存到本系统，不保留外部 URL。',
    },
    description: {
      doc: 'XLSX 两列：A — 编码，B — 图片。数据从第 2 行起。商品须已存在；新图追加（每商品最多 10 张）。',
      ngang:
        'XLSX：A — 编码；B 列起为图片（每格一张）。数据从第 2 行起。商品须已存在；新图追加（每商品最多 10 张）。',
      url: 'XLSX 两列：A — 编码，B — 图片 URL（逗号分隔）。数据从第 2 行起。从客户 CDN 下载后存入本系统；商品须已存在（每商品最多 10 张）。',
    },
    summary: '{rows} 行 · {images} 张图 · {products} 个商品',
    messages: {
      reading: '正在读取文件...',
      empty: '文件无数据',
      noImages: '文件中未找到图片',
      noUrls: '文件中未找到有效图片 URL',
      readFailed: '无法读取导入文件',
      uploading: '正在上传图片 {done}/{total}...',
      fetching: '正在下载并保存图片 {done}/{total}...',
      applying: '正在关联图片到商品...',
      success: '已为 {products} 个商品导入 {ok} 张图片',
      partial: '已为 {products} 个商品导入 {ok} 张图片（有警告）',
      failed: '导入图片失败',
      missingImages: '{count} 行无图片 — 导入时将报错。',
      missingUrls: '{count} 行无图片 URL — 导入时将报错。',
    },
  },
  updateImport: {
    titles: {
      updateFromFile: '导入商品',
      loiValidate: '错误行列表',
      xacNhanImport: '确认更新导入',
      baoCaoKetQua: '更新导入结果报告',
    },
    steps: {
      options: '1. 选项',
      validate: '2. 校验文件',
      apply: '3. 应用',
    },
    sections: {
      conflict: '重复数据处理',
      scope: '应用范围',
      fields: '允许更新的字段',
      file: '数据文件',
    },
    actions: {
      openButton: '导入商品',
      taiFileMau: '下载模板',
      taiFileDuLieu: '下载当前数据文件',
      chonFile: '选择 .xlsx 文件',
      doiFile: '选择其他文件',
      taiFileLoi: '下载错误文件',
      xacNhanImport: '确认导入',
      quayLai: '返回选项',
    },
    options: {
      xuLyTrungMa: {
        label: '编码/条码重复但名称不同？',
        baoLoi: '报错并停止',
        thayThe: '用新名称替换旧名称',
      },
      xuLyMaVach: {
        label: '条码重复但编码不同？',
        baoLoi: '报错并停止',
        thayTheMa: '用新编码替换旧编码',
      },
      phamViGiaVon: {
        label: '成本价应用范围',
      },
      phamViTrangThai: {
        label: '经营状态应用范围',
      },
      toanHeThong: '全网点',
      theoChiNhanh: '按门店',
      capNhatTonKho: { label: '更新库存' },
      capNhatMoTa: { label: '更新描述' },
      capNhatGiaVon: { label: '更新成本价' },
      capNhatDonViQuyDoi: {
        label: '更新换算单位（多单位）',
      },
    },
    placeholders: {
      chonChiNhanh: '选择门店',
      dropFile: '将 Excel 拖放到此处，或点击选择文件',
      fileAccept: '仅支持 .xlsx',
    },
    hints: {
      formatDescription: '使用模板更新商品（重复编码 → 更新，新编码 → 创建）。',
      dataFileDescription:
        '下载含全部当前商品的 Excel → 修改所需列 → 再选择文件进行校验并导入。',
      donViQuyDoiDescription:
        '读取「ĐVT quy đổi」工作表。基础单位（比例 1）缺失会自动添加。仅实物商品，不适用于套餐。',
    },
    messages: {
      validateFailed: '共 {tong} 行中有 {loi} 行错误 — 无法导入',
      validateSuccess: '将更新 {capNhat} 行并创建 {taoMoi} 行',
      applySuccess: '成功处理 {thanhCong} 行，{thatBai} 行失败',
      applyFailed: '更新导入失败，请重试',
      fileSelected: '已选择：{name}',
      chonChiNhanhBatBuoc: '选择「按门店」时请至少勾选一个门店',
      soDongSanSang: '{count} 行已就绪',
      dangKiemTra: '正在检查 {count} 行…',
    },
    report: {
      dong: '行',
      maHang: '编码',
      tenHang: '名称',
      hanhDong: '操作',
      capNhat: '更新',
      taoMoi: '创建',
      chiTietLoi: '错误详情',
      truongThayDoi: '变更字段',
      soDonVi: '单位数',
      tongDong: '总行数',
      soLoi: '错误',
      soCapNhat: '更新',
      soTaoMoi: '创建',
      thanhCong: '成功',
      thatBai: '失败',
    },
  },
  viTriImport: {
    titles: {
      modal: '导入库位',
      loiValidate: '错误行列表',
    },
    sections: {
      options: '导入选项',
    },
    actions: {
      openButton: '导入库位',
      taiFileMau: '下载模板',
    },
    options: {
      taoMoiLabel: '当前门店缺少库位编码时？',
      taoMoi: '新建库位（字母数字保留为编码；其他文字自动生成 VT0001…）',
      khongTaoMoi: '不新建 — 缺少编码则报错',
    },
    hints: {
      description:
        'Excel 两列：商品编码、库位编码。一商品多库位 → 多行相同商品编码（选文件时自动分组）。',
      chiNhanhNote: '库位始终绑定到当前门店。',
    },
    messages: {
      empty: '文件无有效数据',
      failed: '导入库位失败',
      success: '已为 {thanhCong} 个商品绑定库位（新建 {taoMoi} 个库位）',
      soDongSanSang: '{flat} 行 Excel → {count} 个商品可导入',
    },
  },
}
